module.exports = __webpack_public_path__ + "static/img/cry.893925d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/cry.svg
// module id = dchG
// module chunks = 0